import commons from '../../util/commons';

export default {
  localUser: commons.readTodos('localUser'),
  // 首页数据
  homedata: {},
};



// WEBPACK FOOTER //
// ./src/store/asset/state.js